<template>
  <footer>
    <div class="links">
      <a v-if="isPC" href="#" @click.prevent="showTerms()">利用規約</a>
      <router-link v-else to="/terms">利用規約</router-link>
      <a v-if="!isWV" href="https://www.unerry.co.jp/" target="_blank"
        >会社概要</a
      >
      <a
        v-if="!isWV"
        href="https://docs.google.com/forms/d/e/1FAIpQLSemvDN3SG4FstkE_q1Le1I0wrmUjMTtJe9eJAwU30HqQZPB8g/viewform"
        target="_blank"
        >ご要望・お問い合わせ</a
      >
    </div>
    <span>&copy; unerry, inc.</span>

    <transition name="fade">
      <Modal v-if="termsShown" @close="closeTerms()" class="modal">
        <template v-slot:body>
          <Content class="terms" />
        </template>
      </Modal>
    </transition>
  </footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters, mapState } from 'vuex';
import Modal from '@/components/Modal.vue';
import Content from '@/components/Terms/Content.vue';

export default defineComponent({
  name: 'Footer',
  components: {
    Modal,
    Content
  },
  computed: {
    ...mapGetters(['isPC', 'isWV']),
    ...mapState(['selectedPlace'])
  },
  data: function () {
    return {
      termsShown: false
    };
  },
  methods: {
    showTerms() {
      this.termsShown = true;
      window.PageView({
        page_title: '利用規約(PC)',
        page_path: '/terms',
        page_location: location.origin + '/terms'
      });
    },
    closeTerms() {
      this.termsShown = false;

      let title = this.selectedPlace ? this.selectedPlace.name : document.title;
      let current = this.$router.currentRoute.value;
      window.PageView({
        page_title: title,
        page_path: current.fullPath,
        page_location: location.origin + current.fullPath
      });
    }
  }
});
</script>

<style scoped lang="scss">
footer {
  display: flex;
  padding-top: 13px;
  padding-bottom: 17px;
  border-top: 1px solid #eeeeee;

  .links {
    display: flex;

    a {
      margin-left: 20px;
      color: #000;
      font-size: 12px;
      font-weight: bold;

      & + a {
        margin-left: 15px;
      }
    }
  }

  span {
    display: block;
    margin-left: auto;
    margin-right: 20px;
    color: #000;
    font-size: 12px;
    font-weight: bold;
  }
}

@media screen and (max-width: 767px) {
  footer {
    display: block;
    text-align: center;
    padding-top: 15px;

    .links {
      a {
        margin-left: auto;

        &:last-child {
          margin-right: auto;
        }
      }
    }

    span {
      margin: 16px 0 5px;
    }
  }
}

.terms {
  padding: 40px 50px 33px;
}

.modal {
  opacity: 1;

  &.fade-enter-active,
  &.fade-leave-active {
    transition: opacity 0.3s ease;
  }
  &.fade-enter-from,
  &.fade-leave-to {
    opacity: 0;
  }
}
</style>
